import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-game-clicker-clock',
  templateUrl: './game-clicker-clock.component.html',
  styleUrls: ['./game-clicker-clock.component.less']
})
export class GameClickerClockComponent implements OnInit, OnChanges {
  @Input() position: number = 0;
  clockStyle = {
    transform: 'rotate(0deg)',
    transformOrigin: 'center'
  }

  constructor() {

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.position) {
      requestAnimationFrame(() => this.update())
    }
  }

  ngOnInit(): void {

  }
  update() {
    this.clockStyle = {
      transform: 'rotate(' + -this.position + 'deg)',
      transformOrigin: 'center'
    }
  }
}
